import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import IconConstants from "../../utils/IconConstants";
import "./Toaster.scss";
const toster_config = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: "light",
};

let suppressSuccessUntil = 0;

export const suppressNextSuccessToster = (ms = 2000) => {
  suppressSuccessUntil = Date.now() + ms;
};

const shouldSuppressSuccess = () => {
  if (suppressSuccessUntil && Date.now() < suppressSuccessUntil) {
    suppressSuccessUntil = 0;
    return true;
  }
  return false;
};

export const successToster = (msg) => {
  if (shouldSuppressSuccess()) return undefined;
  const isMobile = window.innerWidth <= 700;
  return toast.success(msg, {
    ...toster_config,
    style: {
      width: "max-content",
      color: isMobile ? "#252525" : "#000000",
      backgroundColor: "#DFFFE5",
      borderLeft: "20px solid #62BA60",
      borderRadius: "12px",
      fontWeight: 500,
    },
    icon: ({ theme, type }) => (
      <img
        src={IconConstants.SuccessToaster}
        alt=""
        style={{
          width: isMobile ? "10.256vw" : "40px",
          height: isMobile ? "10.256vw" : "40px",
        }}
      />
    ),
  });
};

let suppressErrorUntil = 0;

export const suppressNextErrorToster = (ms = 2500) => {
  suppressErrorUntil = Date.now() + ms;
};

export const errorToster = (msg) => {
  if (suppressErrorUntil && Date.now() < suppressErrorUntil) {
    suppressErrorUntil = 0;
    return undefined;
  }
  const isMobile = window.innerWidth <= 700;
  return toast.error(msg, {
    ...toster_config,
    style: {
      color: isMobile ? "#252525" : "#000000",
      backgroundColor: "#FFCBC2",
      borderLeft: "20px solid #ED705B",
      borderRadius: "12px",
      fontWeight: 500,
    },
    icon: ({ theme, type }) => (
      <img
        src={IconConstants.ToastErrorIcon}
        alt=""
        style={{
          width: isMobile ? "7.692vw" : "25px",
          height: isMobile ? "7.692vw" : "25px",
          marginRight: isMobile ? "" : "10px",
          marginTop: isMobile ? "5px" : "",
        }}
      />
    ),
  });
};

export const deleteToster = (msg) => {
  if (shouldSuppressSuccess()) return undefined;
  const isMobile = window.innerWidth <= 700;
  return toast.error(msg, {
    ...toster_config,
    style: {
      color: isMobile ? "#252525" : "#000000",
      width: "max-content",
      backgroundColor: "#FFCBC2",
      borderLeft: "20px solid #ED705B",
      borderRadius: "12px",
      fontWeight: 500,
    },
    icon: ({ theme, type }) => (
      <img
        src={IconConstants.ToastDeleteIcon}
        alt=""
        style={{
          width: isMobile ? "10.256vw" : "40px",
          height: isMobile ? "10.256vw" : "40px",
        }}
      />
    ),
  });
};

export const warnToster = (msg) => {
  const isMobile = window.innerWidth <= 700;
  return toast.warn(msg, {
    ...toster_config,
    style: {
      color: isMobile ? "#252525" : "#000000",
      backgroundColor: "#F2E1B8",
      borderLeft: "20px solid #D9A62E",
      borderRadius: "12px",
      fontWeight: 500,
      width: "fit-content",
    },
    icon: ({ theme, type }) => (
      <img
        src={IconConstants.ToastWarnIcon}
        alt=""
        style={{
          width: isMobile ? "10.256vw" : "25px",
          height: isMobile ? "10.256vw" : "25px",
        }}
      />
    ),
  });
};

export const infoToster = (msg) => {
  const isMobile = window.innerWidth <= 700;
  return toast.info(msg, {
    ...toster_config,
    style: {
      color: isMobile ? "#252525" : "#000000",
      backgroundColor: "#E0F0FF",
      borderLeft: "20px solid #3B8FD4",
      borderRadius: "12px",
      fontWeight: 500,
      width: "max-content",
    },
    icon: () => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: isMobile ? "7.692vw" : "28px",
          height: isMobile ? "7.692vw" : "28px",
          borderRadius: "50%",
          backgroundColor: "#3B8FD4",
          color: "#FFFFFF",
          fontSize: isMobile ? "4vw" : "16px",
          fontWeight: 700,
          marginRight: isMobile ? "" : "6px",
          flexShrink: 0,
        }}
      >
        i
      </span>
    ),
  });
};

export const Toster = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover={false}
      theme="colored"
      style={{ width: "max-content" }}
    />
  );
};
